import PaymentErrorPage from '@/pages/PaymentErrorPage/PaymentErrorPage';
export default PaymentErrorPage;
